import * as React from 'react';
import iconUrl from '../../../assets/kickoff-branching-branched.svg';
import dottedIconUrl from '../../../assets/static-branch-diagram-before.svg';

interface MergeBranchesIconProps {
    isDotted: boolean;
}

const MergeBranchesIcon: React.FC<MergeBranchesIconProps> = ({ isDotted }: MergeBranchesIconProps) => {
    const icon = isDotted ? dottedIconUrl : iconUrl;
    return <img src={icon} style={isDotted ? {} : { transform: 'scaleX(-1)' }} />;
};

export default MergeBranchesIcon;
